import React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import { Form, Formik } from 'formik'
import { FormGroup } from 'react-bootstrap'
import { MdClose } from 'react-icons/md'
import ATInput from '../common/formComponent/ATInput'
import ATTextButton from '../common/formComponent/ATTextButton'
import ATHeaderText from '../common/headerText/ATHeaderText'
import ATIconButton from '../common/formComponent/ATIconButton'
import { TEXT_VALIDATION } from '../../utils/constants/UIConstants'
import { PlantRejectFormAttribute } from '../../interface/request/PlantRequest'

interface PlantRejectFormProps {
  initialValues: PlantRejectFormAttribute
  onSave: (values: PlantRejectFormAttribute) => void
  onCloseModal: () => void
  setSelectedPlant: (val: any) => void
}

const PlantRejectForm: React.FC<PlantRejectFormProps> = ({
  initialValues,
  onSave,
  onCloseModal,
  setSelectedPlant,
}) => {
  const { t } = useTranslation(['translation'])
  return (
    <div className="p-2">
      <ATHeaderText title={t('common.reject')}>
        <ATIconButton
          icon={<MdClose size={16} className="text-dark" />}
          onClick={onCloseModal}
          variant="link"
          title="common.close"
        />
      </ATHeaderText>
      <div className="mt-3 px-2">{t('plant.alert_message')}</div>
      <div className="p-2">
        <Formik
          validateOnMount={true}
          enableReinitialize
          initialValues={initialValues}
          validationSchema={Yup.object({
            plantCode: Yup.string().nullable(),
            reasonDescription: Yup.string()
              .trim()
              .required(t('form.required'))
              .min(
                TEXT_VALIDATION.MIN,
                t('common.min_validation', { min_value: TEXT_VALIDATION.MIN }),
              )
              .max(
                TEXT_VALIDATION.MAX,
                t('common.max_validation', { max_value: TEXT_VALIDATION.MAX }),
              ),
          })}
          onSubmit={(values) => {
            onSave(values)
            setSelectedPlant(undefined)
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isValid,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <FormGroup className="col-12">
                  <ATInput
                    label={t('common.reason')}
                    name="reasonDescription"
                    onChangeHandler={handleChange}
                    onBlurHandler={handleBlur}
                    value={values.reasonDescription}
                    isError={
                      errors.reasonDescription && touched.reasonDescription
                    }
                    error={errors.reasonDescription}
                    placeholder=""
                    isMultiLine={true}
                  />
                </FormGroup>
              </div>
              <div className="d-flex py-3 justify-content-end">
                <ATTextButton
                  title={t('common.no')}
                  onPressHandler={onCloseModal}
                  isFilledButton={false}
                />
                <ATTextButton
                  title={t('common.yes')}
                  onPressHandler={handleSubmit}
                  disabled={!isValid}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default PlantRejectForm
